import '../styles/NewChatPage.css'

export const TickIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 16 15"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M6.173 12.728L2.08 8.636l1.414-1.414 2.68 2.68 6.36-6.36 1.414 1.414z" />
  </svg>
);
